import {
  Box, Button, DialogActions, DialogContent, DialogTitle, Grid,
  Typography, Avatar, Autocomplete, Stack, Tooltip, Modal, TextField, Divider, IconButton, InputAdornment, Chip, FormControlLabel,
  CircularProgress
} from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import React, { FC, useEffect, useState, useRef } from 'react';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";
import { StyledInput } from './Dialog.styles';
import { fetchAccountsByName, fetchBuyerOrSupplierByName } from "../../store/accountThunk";
import CustomTextField from '../FormFields/CustomTextField';
import CustomTextField1 from '../FormFields/CustomTextField1';
import Address from './ClientAgent/Address';
import Legal from './ClientAgent/Legal';
import Payment from './ClientAgent/Payment';
import Bank from './ClientAgent/Bank';
import { FormProvider, useForm } from 'react-hook-form';
import { IAccountBasicFormInputs } from "../../utils/account.types";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { ApiStatus } from '../../utils/api.types';
import LoadingButton from '@mui/lab/LoadingButton';
import { addBuyerSellerAccount } from "../../store/accountThunk";
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import { fetchSuppliers } from '../../store/supplierStore/supplierThunk';
import { fetchCustomers } from '../../store/customerStore/customerThunk';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import EmailChip from '../EmailChip/EmailChip';

interface DialogClientFormProps {
  title?: string;
  open: boolean;
  onClose: (k: any) => void;
  onCancel: () => void;
  selectedData: (data: any) => void;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: '0ms',
  width: 1000,
  borderRadius: 2,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
};

const useStyles = makeStyles({
  paper: {
    border: "1.5px solid #e9ecf1",
    boxShadow: 'none',
    borderRadius: 7
  },
  toggleButtonGroup: {
    width: '100%',
  },
  toggleButton: {
    width: 15,
    height: 15,
    marginBottom: 2
  },

});

const DialogClientForm: FC<DialogClientFormProps> = ({ title, onClose, onCancel, open, selectedData, children }) => {
  // Schema to validate account form.
  const schema = yup.object().shape({
    name: yup.string().required("Name is required."),
    legalName: yup.string().required("Legal Name is required."),
    billingAddressCountry: yup.string().required("Billing Address Country is required."),
    billingAddressCity: yup.string().required("Billing Address City is required."),
    shippingAddressCountry: yup.string().required("Shipping Address Country is required."),
    shippingAddressCity: yup.string().required("Shipping Address City is required."),
    // registrationNo: yup.string().required("Registration is required."),
    // countryOfRegistration: yup.string().required("Country of registration is required."),
    // stateOfRegistration: yup.string().required("State of registration is required."),
    // taxIdentificationNumber1: yup.string().required("Tax Identification #1 (PAN for India) is required."),
    // taxIdentificationNumber2: yup.string().required("Tax Identification #2 (GST for India) is required."),
    // upiId: (title === 'Supplier') ? yup.string().required("UPI ID is required.") : yup.string().notRequired(),
    // gPayPhone: (title === 'Supplier') ? yup.string().required("GPay number is required.") : yup.string().notRequired(),
    // bankName: (title === 'Supplier') ? yup.string().required("Bank name is required.") : yup.string().notRequired(),
    // branchName: (title === 'Supplier') ? yup.string().required("Branch name is required.") : yup.string().notRequired(),
    // IFSC: (title === 'Supplier') ? yup.string().required("IFSC is required.") : yup.string().notRequired(),
    currency: (title === 'Supplier') ? yup.string().required("Supplier is required.") : yup.string().notRequired(),
    // accountNumber: (title === 'Supplier') ? yup.string().required("Account number is required.") : yup.string().notRequired(),
    // accountName: (title === 'Supplier') ? yup.string().required("Account name is required.") : yup.string().notRequired()
  });

  const dispatch = useAppDispatch();
  const classes = useStyles();
  const [image, setImage] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [options, setOptions] = useState<any[]>([]);
  const [selected, setSelected] = useState<any>();
  const [newOption, setNewOption] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [saveButton, setSaveButton] = useState('Select');
  const { selectedAccount } = useAppSelector(state => state.auth);
  const elmRef = useRef<any>(null);
  const [mailerList, setMailerList] = useState<any>();
  const [isClientEdit, setIsClientEdit] = useState<any>();
  
  const [searchTerm, setSearchTerm] = useState('');   // Track user input
  const [debouncedTerm, setDebouncedTerm] = useState(searchTerm); // Debounced value
  const TIME_DELAY = 500;

  // use form
  const methods = useForm<IAccountBasicFormInputs>({
    resolver: yupResolver(schema),
  });
  const formRef = useRef<any>();

  const { status } = useAppSelector(state => state.account);

  // Method to set preview of selected picture.
  const handleSelectFile = (event: any) => {
    const target = event.target as HTMLInputElement;

    if (target.files && target.files[0]) {
      setSelectedFile(target.files[0]);
      setImage(URL.createObjectURL(target.files[0]));
    }
  };
  const onChangeHandler = (event: any, value: any) => {
    console.log("onChangeHandler called", value);
    setNewOption('');
    // setIsLoading(true);
    setSelected(value);
    setIsClientEdit(false);
    // setIsLoading(false);
  }
  // Update the debounced value after a delay (debouncing the user input)
  useEffect(() => {
    setIsLoading(true);
    const timerId = setTimeout(() => {
      setDebouncedTerm(searchTerm);
      setIsLoading(false);
    }, 500);  // 500ms delay
    
    return () => clearTimeout(timerId); // Cleanup previous timer on new keypress
  }, [searchTerm]);

  // Make API call when debouncedTerm changes (user has stopped typing)
  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const _querystring = `name=${debouncedTerm}&&searchFor=${title?.toLocaleLowerCase()}`
        await dispatch(fetchBuyerOrSupplierByName(_querystring)).unwrap().then((data) => {
          if (data) {
            const d = data.accounts.filter(function (item) {
              return item._id !== selectedAccount._id;
            });

            // When no search term, show first 5 results
            setOptions(debouncedTerm ? d : d.slice(0, 5));
          }
        });
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
      setTimeout(() => {setIsLoading(false)}, TIME_DELAY);
    };

    fetchData();
  }, [debouncedTerm]); // Run when debouncedTerm changes

  const onInputChangeHandler = async (event: React.SyntheticEvent, value: string) => {
    setSearchTerm(value);
  };

  // const onInputChangeHandler = async (event: React.SyntheticEvent, value: string) => {
  //   setSelected('');
  //   setNewOption('');
  //   const { _id: id } = selectedAccount;
  //   // let option = [];
  //   // const data: any = await dispatch(fetchCustomers(id));
  //   // console.log(data)

  //   // if (data.payload.length > 0) {
      
  //   //   option = data.payload.map((item: any) => {
  //   //     console.log(item);
  //   //     return { label: item.name, value: item._id }
  //   //   });
  //   // }
  //   // console.log("setting up options");
  //   // console.log(option);
  //   // setOptions(option);


  //   // await dispatch(fetchCustomers(id)).unwrap().then((data) => {
  //   //   console.log(data)
  //   //   if (data) {
  //   //     console.log("checking customer data");
  //   //     console.log(data.customers);
  //   //     let option = [];
  //   //     option = data.customers.filter((item: any) => {
  //   //       console.log(item);
  //   //       return { label: item.name, value: item._id }
  //   //     });

  //   //     console.log(option);

  //   //     setOptions(option);

  //   //     // const d = data.customers.filter(function (item) {
  //   //     //   return item._id !== selectedAccount._id;
  //   //     // });

  //       setOptions(option);
  //   //   }
  //   // });
  // // };

  // const onInputChangeHandler = async (event: React.SyntheticEvent, value: string) => {
  //   setSelected('');
  //   setNewOption('');
  //   console.log("input changed called");
  //   if (selectedAccount) {
  //     const { _id: id } = selectedAccount;
  //     const data: any = await dispatch(fetchCustomers(id));
  //     console.log(data);

  //     if (data.payload.length > 0) {
  //       let option = [];
  //       option = data.payload.map((item: any) => {
  //         console.log(item);
  //         return { label: item.name, value: item._id }
  //       });
  //       setOptions(option);
  //     }
  //   }
  // };

  const onAddNew = () => {
    if (elmRef) {
      const ele = elmRef?.current.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
      if (ele) ele.click();
    }
    setIsClientEdit(true);
    setSelected('')
    setNewOption('');
    setSaveButton('Create')
    setNewOption('new');
  };

  useEffect(() => {
    methods.reset();
    if (selected) {
      methods.setValue("name", selected.name);
      methods.setValue("legalName", selected.legalName);
      methods.setValue("website", selected.website);
      methods.setValue("contactName", selected.contactName);
      methods.setValue("email", selected.email);
      methods.setValue("whatsAppNumber", selected.whatsAppNumber);
      setIsLoading(false);
    } else if (newOption) {
      setIsLoading(false);
    }
  }, [selected, newOption, methods, isClientEdit]);

  const getFormData = (object: any) => {
    const formData = new FormData();
    Object.keys(object).forEach(key => formData.append(key, object[key]));
    return formData;
  };

  const createClient = async (e: any) => {
    if (selectedFile) {
      e.append('logo', selectedFile);
    }

    e.delete('email');
    e.append('email', JSON.stringify(mailerList));

    const resData: any = await dispatch(addBuyerSellerAccount(e));

    if (resData.payload) {
      setSelected(resData.payload.fullAccountDetails);
      selectedData(resData.payload.fullAccountDetails);
    }
    if (!resData.error) {
      onClose(true);
      // setIsClientEdit(false)
      methods.reset();
    }
  };

  const handleRenderOption = (e: any, b: any, c: any) => {
    // console.log('b.counterPartyOfAccount: ', b.counterPartyOfAccount, b.name);
    return isLoading ? <div style={{ 'marginLeft': '20px' }}><CircularProgress color="info" size={20}/></div> : <div {...e} className='auto-item' key={Math.random()}>
      <div className='img-wrapper'>
        <Avatar
          alt={b.name}
          imgProps={{ referrerPolicy: "no-referrer" }}
          src={b.logo}
          variant='square'
          style={{
            width: "30px",
            height: "30px",
            objectFit: "contain",
          }}
          sizes={"xs"}
        >{b.name.toString().substr(0, 1).toUpperCase()}</Avatar>
      </div>
      <div><b style={{ 'marginRight': '4px' }}>
        {b.name}
      </b>
        {!b.counterPartyOfAccount && <Tooltip title="Verified account"><InfoIcon style={{ fontSize: '12px', color: '#09b2ee' }}></InfoIcon></Tooltip>}
        {b.counterPartyOfAccount && <Tooltip title="My customer / vendor"><InfoIcon style={{ fontSize: '12px', color: '#aaa' }}></InfoIcon></Tooltip>}
      </div>
    </div>
  };

  const selectedEmailDataHandler = (data: any) => {
    console.log("====> selectedEmailDataHandler called from updateClientForm  ====> ");
    setMailerList(data);
    console.log(mailerList);
  };

  const onSubmit = (e: any) => {

    const data = methods.getValues();
    data.buyerSellerAgent = title;
    data.email = mailerList;
    console.log(data);

    delete e.search;
    e.buyerSellerAgent = title;
    
    let form = getFormData(data);
    createClient(form);
  };

  return (
    <div className="drawer-form-container">
      <Modal
          open={open}
          onClose={(event : any, reason:any) => {
              if (reason !== 'backdropClick') {
                onClose(false);
              }
          }}
      >
      <FormProvider {...methods}>
          <Box sx={style} component="form" onSubmit={methods.handleSubmit(data => onSubmit(data))} ref={formRef} noValidate>
            <Grid container>
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
                <div style={{float:'right',marginTop:-7,marginRight:-5}}>
                    
                  {selected &&
                    <Button 
                      style={{color:'#488dff',backgroundColor:'#fff',border:'1px solid #488dff', marginRight:10 }}
                      variant="contained"
                      size='small'
                      onClick={() => {
                        methods.reset();
                        selectedData(selected);
                        setSelected('');
                        setNewOption('');
                        setSaveButton('Select')
                        onClose(false);
                      }} > Select </Button>
                  }
                  {newOption == 'new' && 
                    <LoadingButton
                      type="submit"
                      name={'submit'}
                      // disabled={!methods.formState.isValid}
                      loading={status === ApiStatus.LOADING}
                      style={{color:'#488dff',backgroundColor:'#fff',border:'1px solid #488dff', marginRight:10 }}
                      variant="contained"
                      size='small'
                    > {saveButton} </LoadingButton> 
                  }

                  <Button
                    style={{color:'#488dff',backgroundColor:'#fff',border:'1px solid #488dff', marginRight:10 }}
                    variant="contained"
                    size='small'
                    onClick={() => {
                      methods.reset();
                        setSelected('');
                        setNewOption('');
                        onCancel();
                        onClose(false);
                    }}>
                    Cancel
                  </Button>
                    {/* <IconButton size='small' 
                      onClick={() => {
                        methods.reset();
                        setSelected('');
                        setNewOption('');
                        onCancel();
                        onClose(false);
                      }}
                      style={{marginRight:-5}} 
                      >
                      <HighlightOffOutlinedIcon  color="error"/>
                    </IconButton> */}
                </div>
                <h3  style={{marginTop:-2}}>Search {title}</h3>
                
                </Grid>
                
            </Grid>
            <Grid container spacing={2} rowSpacing={1} p={2} height={'90vh'} overflow={'auto'}>

              {/* {JSON.stringify(methods.formState.errors) || {}} */}

              <Grid item xs={8} >
                <h5 className='c-label2'>{`Search ${title}`}</h5>
                <Autocomplete
                  ref={elmRef}
                  id={`search ${title}`}
                  disablePortal
                  onChange={onChangeHandler}
                  onInputChange={onInputChangeHandler}
                  // onInputChange={(e) => setSearchTerm(e)}
                  options={options}
                  renderOption={handleRenderOption}
                  classes={{ paper: classes.paper }}
                  sx={{ width: '100%'}}
                  getOptionLabel={option => option.name}
                  renderInput={(params) => <TextField {...params}
                  placeholder={`Type here to Search ${title}`}
                    required 
                    className='c-text-field' 
                    variant="standard" 
                    size='medium'
                    InputProps={{...params.InputProps, disableUnderline: true}}
                  />}
                />
              </Grid>

              <Grid item xs={4} >
              {!selected && 
                <Button variant='contained' size='small' onClick={onAddNew}
                  style={{ marginTop: '18px', color:'#488dff',backgroundColor:'#fff',border:'1px solid #488dff', float:'right' }} >
                    Add New {title}
                </Button>
              }
              {/* <Tooltip title="Add new"><AddIcon style={{ cursor: 'pointer', marginTop: '16px' }} onClick={onAddNew} fontSize="medium" /></Tooltip> */}
              </Grid>

              <Grid item xs={12} mb={1}>
                <Divider/>
              </Grid>

              {isLoading ? <div></div> : (selected || (newOption)) && (
                <>
                  <Grid item xs={2} >
                        <Avatar
                          alt={"Picture"}
                          imgProps={{ referrerPolicy: "no-referrer" }}
                          src={(selected && selected.logo) ? selected.logo : image}
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "contain",
                            marginBottom:10,
                            border:'1px dashed #9da7b7',
                            marginLeft:15
                          }}
                          variant='rounded'
                          sizes={"lg"}
                        />
                      {!selected && <label htmlFor="logo">
                        <StyledInput
                          accept="image/*"
                          id="logo"
                          type="file"
                          onChange={handleSelectFile}
                        />
                        <Button
                        style={{marginLeft:15, width:'120px', color:'#488dff',backgroundColor:'#fff',border:'1px dashed #488dff' }}
                          variant="contained"
                          component="span"
                          size='small'
                        >
                          Choose Logo
                        </Button>
                      </label>}
                  </Grid>
                  <Grid item xs={10}>
                  <Grid container spacing={2} rowSpacing={1}>

                  <Grid item xs={7.2} >
                  <h5 className='c-label'>Name*</h5>
                    <TextField
                    className='c-text-field' 
                    {...methods.register('name')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected) ? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.name?.message ?? ""}</p>
                  </Grid>
                  <Grid item xs={4.8}>
                  <h5 className='c-label'>Legal Name *</h5>
                    <TextField
                    placeholder='legalName' 
                    required 
                    className='c-text-field' 
                    {...methods.register('legalName')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected) ? true : false
                    }}/> 
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.legalName?.message ?? ""}</p>
                  </Grid>
                  <Grid item xs={7.2}>
                  <h5 className='c-label'>Website</h5>
                    <TextField
                    placeholder='website' 
                    className='c-text-field' 
                    {...methods.register('website')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected) ? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.website?.message ?? ""}</p>
                    </Grid>

                  <Grid item xs={4.8}>
                  <h5 className='c-label'>Contact Name</h5>
                    <TextField
                    placeholder='Contact Name' 
                    className='c-text-field'
                    {...methods.register('contactName')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected) ? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.contactName?.message ?? ""}</p>
                  </Grid>
                  <Grid item xs={7.2}>
                    {/* <CustomTextField label="Email" name="email" variant="standard" InputProps={{ readOnly: (selected) ? true : false }} /> */}
                    <EmailChip buyerEmail={selected.email} methods={methods} selectedEmailData={selectedEmailDataHandler} isEdit={isClientEdit}/>
                  </Grid>
                  <Grid item xs={4.8}>
                  <h5 className='c-label'>WhatsApp Number</h5>
                    <TextField
                    placeholder='WhatsApp Number' 
                    type='number'
                    className='c-text-field'
                    {...methods.register('whatsAppNumber')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected) ? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.whatsAppNumber?.message ?? ""}</p>
                  </Grid>
                  </Grid>
                  </Grid>
                  <Address selected={selected} methods={methods} />

                  {title == 'Supplier' &&
                  <>
                  <Grid item xs={6} mt={1}>
                    <Divider style={{marginRight:-8}}>
                      <Chip label="UPI Details " size="small" />
                    </Divider>
                  </Grid>
                  <Grid item xs={6} mt={1}>
                    <Divider style={{marginLeft:-8}}>
                      <Chip label="Bank Details " size="small" />
                    </Divider>
                  </Grid>
                  <Grid item xs={6.1} pr={2}>
                    <Grid container spacing={2} rowSpacing={1} pt={-2}>
                      <Payment selected={selected} methods={methods} />
                    </Grid>
                  </Grid>
                  <Grid item xs={5.9} style={{borderLeft:'1px solid rgba(0, 0, 0, 0.12)'}}>
                    <Grid container spacing={2} rowSpacing={1} >
                      <Bank selected={selected} methods={methods} />
                    </Grid>
                  </Grid>
                  </>
                  }

                  <Legal selected={selected} methods={methods} />
                  {/* {title === 'Supplier' && <Payment selected={selected} methods={methods} />}
                  {title === 'Supplier' && <Bank selected={selected} methods={methods} />} */}
                </>
              )}
            </Grid>
            {/* <Grid container gap='0' sx={{ mr: '32px', pt: '10px' }}>
            <Grid item xs={4} display="flex" justifyContent="flex-end" >
                <Button variant='outlined'
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    methods.reset();
                    onCancel();
                    onClose(false);
                  }}>Cancel</Button>
                {selected ?
                  <Button variant='contained'
                    style={{ marginRight: '10px' }}
                    onClick={() => {
                      methods.reset();
                      selectedData(selected);
                      onClose(false);
                    }}>Select</Button> :
                  <LoadingButton
                    type="button"
                    onClick={onSubmit}
                    // disabled={!methods.formState.isValid}
                    loading={status === ApiStatus.LOADING}
                    variant="contained"
                  >
                    {saveButton}
                  </LoadingButton>}
              </Grid>
            </Grid> */}
        </Box>
      </FormProvider>
      </Modal>
    </div >
    
  );
};

export default DialogClientForm;
